import React, { useEffect, useContext } from "react";
import { Authentication } from "@swegon/sds-core";

export const Signout = () => {
    const { signOut } = useContext(Authentication.AuthContext);
    useEffect(() => {
        signOut();
    });
    return <></>;
};

export default Signout;
